import script from "./IEventsListCol.vue?vue&type=script&setup=true&lang=js"
export * from "./IEventsListCol.vue?vue&type=script&setup=true&lang=js"

import "./IEventsListCol.vue?vue&type=style&index=0&id=1de6f6a0&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1de6f6a0"]])

export default __exports__